import axios from 'axios';
import { clearLocalStorage } from './clearlocalstorage';
import { logApiError } from './logger';

const axiosApiFunction = (method, endpoint, paramsobj, token, body = null, componentName = 'Unknown') => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: `${process.env.REACT_APP_BACKEND_BASEURL}${endpoint}`,
      params: paramsobj,
      headers: {
        'Content-Type': 'application/json', // Adjust as needed
        'Accept': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      data: body, // Include body in the request
    })
      .then(response => {
        resolve(response); // Resolve with the response data
      })
      .catch(error => {
        // Log all API errors to the log file
        logApiError(endpoint, error, componentName);

        if (error.response && error.response.status === 401) {
          // Redirect to login page if unauthorized
          // clearLocalStorage();

          const id = localStorage.getItem("encryptedData");
          localStorage.removeItem("userData");
          localStorage.removeItem("tokenData");

          if (id === null) {
            window.location.href = "/";
          } else {
              window.location.href = `/${id}`;
          }
        } else {
          reject(error); // Reject with other errors
        }
      });
  });
};

export default axiosApiFunction;
